<template>
    <el-form >
        <el-form-item label="关联账号：" label-width="100px">

            <el-button type="primary" icon="el-icon-circle-plus-outline" size="mini" @click="showRelation=true">
                关联账号
            </el-button>
            <template>
                <el-table :data="relationAccounts" border>
                    <el-table-column
                            prop="userId"
                            label="用户ID">
                    </el-table-column>
                    <el-table-column
                            prop="username"
                            label="用户名">
                    </el-table-column>
                    <el-table-column
                            prop="realName"
                            label="真实姓名">
                    </el-table-column>

                    <el-table-column
                            prop="deviceList"
                            label="已授权设备" width="150px">
                        <template slot-scope="scope">
                            <p v-for="(item, index) in scope.row.deviceList " :key="index"> {{item.os}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="账号登录日志" width="220px">
                        <template slot-scope="scope">
                            <template v-if="scope.row.loginLogs && scope.row.loginLogs.length">
                                <span>{{scope.row.loginLogs[0].loginIp}}<br>{{scope.row.loginLogs[0].loginAt}}</span>
                                <el-tooltip v-if="scope.row.loginLogs.length > 1" placement="top" effect="dark">
                                    <div slot="content">
                                        <p v-for="item in scope.row.loginLogs.slice(1)" :key="item.id">
                                            {{item.loginIp}}<br>{{item.loginAt}}
                                        </p>
                                    </div>
                                    <el-button type="text" size="small">更多</el-button>
                                </el-tooltip>
                            </template>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.deviceList.length > 0 && Acs('/customer/accounts/delete-user-device-id')" @click="DeleteUserDeviceId(scope.row.userId)"  type="text" size="small">撤销已授权设备</el-button>
                            <el-button @click="unblockLogin(scope.row.username)"  type="text" size="small">解封登录</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <relation-dialog ref="account" service="paike_new" :title="'关联账号'"
                             :customerId="$route.query['id']"
                             @handleClose="closeRelationDialog" 
                             @relationAccount="relationAccount"
                             :is-show="showRelation"
                             :schoolId="schoolId"
                             >
                            </relation-dialog>
        </el-form-item>
    </el-form>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>

<script>
    import RelationDialog from "~/views/customer/dialog/relationDialog.vue";
    import AccountService from "~/services/CustomerAccounts";
export default {
    components:{
        RelationDialog,
    },
    props: {
        accounts: {
                type: Array,
                default: [],
                required: false,
        },
        schoolId: {
            type: String,
            required:false
        },
    },
    created: function () {

        this.relationAccounts = [...this.accounts];
        // AccountService.getAccounts({
        //     customer_id: this.$route.query['id'],
        //     service: 'paike_new',
        // }).then(res => {
        //     if (res.data) {
        //         this.relationAccounts = [];
        //         this.relationAccounts = res.data;
        //         this.loading = false;
        //       //  this.emit();
        //     }
        // })
    },
    data() {
        return {
            input_size:'mini',
            subjects:[],
            relationAccounts: [],
            configUsed:false,
            formLabelWidth:'120px',
            multipleSelection: [],
            formInline: {
                user: '',
                region: ''
            },
            showRelation: false,
            showIsAlreadyRelation:false
        };
    },
    watch:{
        accounts: function (val) {
            this.relationAccounts = [...val];
        }
    },
    methods:{
        DeleteUserDeviceId(uid) {
            this.$confirm("此操作将撤销在其他客户端的访问权限！", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                AccountService.deleteUserDeviceId({
                    uid: uid,
                    type:1,
                }).then(res => {
                    if (res.code == 0) {
                        //重新请求列表
                        // AccountService.getAccounts({
                        //     customer_id: this.$route.query['id'],
                        //     service: 'paike_new',
                        // }).then(res => {
                        //     if (res.code==0) {
                        //         this.relationAccounts = res.data;
                        //         this.$message({
                        //             message: "撤销成功!",
                        //             type: "success"
                        //         });
                        //     }
                        // })

                        this.$emit('afterDeleteDevice')
                    }
                })
            }).catch(() => {
            });
        },

        unblockLogin(username){
            this.$confirm("确定要解封该账号登录吗！", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                AccountService.unblockLogin({
                    username: username,
                }).then(res => {
                    if (res.code == 0) {
                        this.$emit('afterDeleteDevice')
                    }
                })
            }).catch(() => {

            });
        },

        closeRelationDialog(show) {
            this.showRelation = show;
            this.showIsAlreadyRelation = show;
        },
        /**
         * 关联账号
         * */
        relationAccount(data) {
            this.$emit('relationAccount', data, () => {
                AccountService.getAccounts({
                    customer_id: this.$route.query['id'],
                    service: 'paike_new',
                }).then(res => {
                    if (res.code==0) {
                        this.relationAccounts = res.data;
                    }
                })
             //   this.relationAccounts = data;
            });
        },
        onSubmit() {
            console.log('submit!');
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/order/paike/AccountSettings.vue